/* TDN Social page — assets/tdn-social.js
   - Passes incoming UTM / click-id params through to internal links
   - Click tracking (dataLayer / gtag / Meta / TikTok if present)
   - Direct add-to-cart via /cart/add.js
   - Tags the cart with attributes so orders from this page are identifiable in Shopify admin */
(function () {
  if (window.TDNSocial) return;

  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'gclid', 'fbclid', 'ttclid'];
  var KEY = 'tds_params';
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
  var tagged = false;

  function safeGet() { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function safeSet(o) { try { sessionStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  // 1. Capture params from the landing URL (persist for the session)
  var params = safeGet();
  var qs = new URLSearchParams(location.search);
  var found = false;
  PARAMS.forEach(function (p) { if (qs.get(p)) { params[p] = qs.get(p); found = true; } });
  if (found) safeSet(params);

  // 2. Append params to internal links
  function decorate(a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      if (u.hostname !== location.hostname) return;
      PARAMS.forEach(function (p) { if (params[p] && !u.searchParams.has(p)) u.searchParams.set(p, params[p]); });
      a.setAttribute('href', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  function decorateAll(root) {
    (root || document).querySelectorAll('a[data-tds-track]').forEach(decorate);
  }

  // 3. Event helpers
  function push(name, data) {
    data = data || {};
    window.dataLayer = window.dataLayer || [];
    var payload = { event: name };
    for (var k in data) payload[k] = data[k];
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') window.gtag('event', name, data);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', name, data);
  }

  function attributes() {
    var a = { social_page: 'yes', social_landing: location.pathname };
    PARAMS.forEach(function (p) { if (params[p]) a['social_' + p] = params[p]; });
    return a;
  }
  function tagCart() {
    if (tagged) return Promise.resolve();
    tagged = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes() }),
      keepalive: true
    }).catch(function () {});
  }

  // 4. Click tracking (delegated)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-tds-track]');
    if (!a) return;
    var type = a.getAttribute('data-tds-type') || 'link';
    push('tds_click', {
      tds_section: a.getAttribute('data-tds-section') || '',
      tds_type: type,
      tds_label: a.getAttribute('data-tds-label') || '',
      tds_position: a.getAttribute('data-tds-pos') || '',
      tds_url: a.getAttribute('href') || ''
    });
    // Only tag the cart when heading into the store (products, needs, stories)
    if (type === 'product' || type === 'need' || type === 'story' || type === 'shop') tagCart();
  }, true);

  // 5. Variant select
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('.tds-atc select');
    if (!sel) return;
    var form = sel.closest('.tds-atc');
    var opt = sel.options[sel.selectedIndex];
    form.setAttribute('data-variant', opt.value);
    form.setAttribute('data-price', opt.getAttribute('data-price') || '');
    var priceEl = form.closest('.tds-prod').querySelector('[data-tds-price]');
    if (priceEl && opt.getAttribute('data-money')) priceEl.firstChild.nodeValue = opt.getAttribute('data-money');
    var btn = form.querySelector('button');
    var avail = opt.getAttribute('data-available') !== 'false';
    btn.disabled = !avail;
    btn.textContent = avail ? btn.getAttribute('data-label') : btn.getAttribute('data-soldout');
  });

  // 6. Add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('.tds-atc');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var msg = form.parentNode.querySelector('.tds-prod__msg');
    var id = parseInt(form.getAttribute('data-variant'), 10);
    if (!id || btn.disabled) return;
    var label = btn.getAttribute('data-label');
    btn.disabled = true; btn.textContent = btn.getAttribute('data-adding');
    if (msg) msg.textContent = '';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      tagged = false; return tagCart();
    }).then(function () {
      var title = form.getAttribute('data-title');
      var value = (parseInt(form.getAttribute('data-price'), 10) || 0) / 100;
      var pid = form.getAttribute('data-product');
      push('tds_add_to_cart', { tds_label: title, tds_section: 'featured_products' });
      // GA4 ecommerce
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: 'add_to_cart', ecommerce: { currency: currency, value: value, items: [{ item_id: pid, item_variant: String(id), item_name: title, price: value, quantity: 1 }] } });
      if (typeof window.gtag === 'function') window.gtag('event', 'add_to_cart', { currency: currency, value: value, items: [{ item_id: pid, item_name: title, price: value, quantity: 1 }] });
      if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', { content_ids: [pid], content_name: title, content_type: 'product', value: value, currency: currency });
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('AddToCart', { content_id: pid, content_name: title, value: value, currency: currency });

      btn.textContent = btn.getAttribute('data-done');
      if (msg) msg.innerHTML = 'Added. <a href="/cart">View cart</a>';
      document.dispatchEvent(new CustomEvent('tds:added', { detail: { variantId: id } }));
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
    }).catch(function () {
      btn.disabled = false; btn.textContent = label;
      if (msg) msg.innerHTML = 'Could not add. <a href="' + form.getAttribute('data-url') + '">View product</a>';
    });
  });

  // 7. Page view + init
  function init() {
    decorateAll();
    push('tds_page_view', { tds_path: location.pathname, utm_source: params.utm_source || '', utm_medium: params.utm_medium || '', utm_campaign: params.utm_campaign || '' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { decorateAll(e.target); });

  window.TDNSocial = { push: push, params: params };
})();